import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface LetContext<T> {
  asconLet: T | null;
}

@Directive({
  selector: '[asconLet]'
})

export class LetDirective<T> {
  private readonly _context: LetContext<T> = { asconLet: null };

  constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef<LetContext<T>>) {
    viewContainer.createEmbeddedView(templateRef, this._context);
  }

  @Input()
  set asconLet(value: T) {
    this._context.asconLet = value;
  }
}
